export function getMonday(date: Date): Date {
  const d = new Date(date);
  const day = d.getDay();
  const diff = d.getDate() - day + (day === 0 ? -6 : 1);
  d.setDate(diff);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function addDays(date: Date, days: number): Date {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
}

export function toISO(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function fromISO(iso: string): Date {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y, m - 1, d, 0, 0, 0, 0);
}

export function unlockAtForMonday(monday: Date): Date {
  const unlock = addDays(monday, -5);
  unlock.setHours(12, 0, 0, 0);
  return unlock;
}

export function deadlineForDate(date: Date): Date {
  const deadline = addDays(date, -2);
  deadline.setHours(12, 0, 0, 0);
  // Fällt die Frist auf Samstag oder Sonntag → vorherigen Freitag nehmen
  const day = deadline.getDay();
  if (day === 6) deadline.setDate(deadline.getDate() - 1); // Samstag → Freitag
  if (day === 0) deadline.setDate(deadline.getDate() - 2); // Sonntag → Freitag
  return deadline;
}

export function isWeekUnlocked(monday: Date): boolean {
  return new Date() >= unlockAtForMonday(monday);
}

export function isOrderable(dateISO: string): boolean {
  const date = fromISO(dateISO);
  const deadline = deadlineForDate(date);
  return new Date() < deadline;
}

export function formatDate(date: Date): string {
  return date.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function formatDateShort(date: Date): string {
  return date.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit' });
}

export function formatDateLong(date: Date): string {
  return date.toLocaleDateString('de-DE', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' });
}

export function formatDeadline(dateISO: string): string {
  const date = fromISO(dateISO);
  const deadline = deadlineForDate(date);
  return deadline.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function getWeekDays(monday: Date): Date[] {
  return Array.from({ length: 5 }, (_, i) => addDays(monday, i));
}

export function formatWeekLabel(monday: Date): string {
  const friday = addDays(monday, 4);
  const monthM = monday.toLocaleDateString('de-DE', { month: 'long' });
  const monthF = friday.toLocaleDateString('de-DE', { month: 'long' });
  if (monthM === monthF) {
    return `${monday.getDate()}. – ${friday.getDate()}. ${monthM} ${monday.getFullYear()}`;
  }
  return `${monday.getDate()}. ${monthM} – ${friday.getDate()}. ${monthF} ${monday.getFullYear()}`;
}

export function formatMonthYear(dateISO: string): string {
  const date = fromISO(dateISO);
  return date.toLocaleDateString('de-DE', { month: 'long', year: 'numeric' });
}

export function getCalendarWeek(date: Date): number {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil((((d.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
}

export const WEEKDAY_NAMES = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag'];
